import React from "react";

// Search and filter row, laid out like the @shadcndesign table-header-1 block.
const TableFilterBar = ({ search, filters, trailing }) => (
  <div className="flex flex-col items-stretch gap-3 md:flex-row md:items-center">
    {search}
    {filters ? (
      <div className="flex min-w-0 flex-wrap items-center gap-2">{filters}</div>
    ) : null}
    <div className="grow" />
    {trailing ? (
      <div className="flex flex-wrap items-center gap-2">{trailing}</div>
    ) : null}
  </div>
);

export default TableFilterBar;
